/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
          <GridContainer >

            <GridItem xs={12} sm={12} md={6} style={{textAlign: "left"}}>

                  <a
                    href="/"
                    className={classes.block}
                  >
                    Home
                  </a>

                  <a
                    href="#aboutAnchor"
                    className={classes.block}
                  >
                    About us
                  </a>

                  <a
                    href="#galleryAnchor"
                    className={classes.block}
                  >
                    Gallery
                  </a>

                  <a
                    href="#contactAnchor"
                    className={classes.block}
                  >
                    Gallery
                  </a>


            </GridItem>

            <GridItem xs={12} sm={12} md={6} className={classes.block} style={{textAlign: "right"}}>

                  <span className={classes.block}>
                    VIP Painting & Decorating
                  </span>

                  <a
                    href="tel:0430 200 526"
                    className={classes.block}
                  >
                    0430 200 526
                  </a>
                  <span className={classes.block}>
                    24 Ritchie St
                    Rosehill, NSW, 2142
                  </span>

            </GridItem>

          </GridContainer>

      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
